import { useState } from "react";
import FadeUp from "./FadeUp";
import { CONTACT } from "../data/content";
import { DEST_IMAGES } from "../data/images";

const TOURS = [
  {
    title: "Indore – Bhopal One Way",
    location: "Indore → Bhopal",
    duration: "2.5 hrs",
    price: "₹3,200",
    rating: "4.9",
    badge: "-30% OFF",
    badgeColor: "bg-accent",
    img: DEST_IMAGES.bhopal.card,
  },
  {
    title: "Indore – Ujjain Darshan",
    location: "Mahakaleshwar",
    duration: "Full Day",
    price: "₹2,499",
    rating: "5.0",
    badge: "Featured",
    badgeColor: "bg-brand",
    img: DEST_IMAGES.ujjain.card,
  },
  {
    title: "India Temple Circuit",
    location: "Ujjain · Omkareshwar",
    duration: "2 Days",
    price: "₹8,900",
    rating: "4.8",
    badge: "Featured",
    badgeColor: "bg-brand",
    img: DEST_IMAGES.omkareshwar.card,
  },
  {
    title: "Pachmarhi Hill Package",
    location: "Pachmarhi",
    duration: "3 Days",
    price: "₹14,500",
    rating: "4.9",
    badge: "-30% OFF",
    badgeColor: "bg-accent",
    img: DEST_IMAGES.pachmarhi.card,
  },
];

function HeartButton() {
  const [liked, setLiked] = useState(false);
  return (
    <button
      onClick={() => setLiked((v) => !v)}
      aria-label="Save tour"
      className="grid h-9 w-9 place-items-center rounded-full bg-white/90 text-lg shadow-soft transition-transform hover:scale-110"
    >
      <span className={liked ? "text-accent" : "text-navy/40"}>
        {liked ? "♥" : "♡"}
      </span>
    </button>
  );
}

export default function FeaturedTours() {
  return (
    <section id="tours" className="bg-gradient-to-br from-brand to-brand-dark py-20 text-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <FadeUp>
          <div className="mb-10 flex flex-wrap items-end justify-between gap-4">
            <div>
              <p className="section-label text-white/80">← Featured Tours →</p>
              <h2 className="font-heading text-3xl font-bold sm:text-4xl">
                Popular Tour Packages
              </h2>
            </div>
            <p className="max-w-sm text-white/80">
              Fixed-fare packages with professional chauffeurs, clean vehicles
              and instant confirmation.
            </p>
          </div>
        </FadeUp>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {TOURS.map((t, i) => (
            <FadeUp key={t.title} delay={i * 0.1}>
              <div className="group flex h-full flex-col overflow-hidden rounded-card bg-white text-navy shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-cardHover">
                {/* Photo */}
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={t.img}
                    alt={t.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <span className={`absolute left-3 top-3 rounded-full ${t.badgeColor} px-3 py-1 text-xs font-semibold text-white`}>
                    {t.badge}
                  </span>
                  <div className="absolute right-3 top-3">
                    <HeartButton />
                  </div>
                </div>

                {/* Body */}
                <div className="flex flex-1 flex-col p-5">
                  <div className="mb-2 flex items-center gap-1 text-sm text-amber-500">
                    ★ <span className="font-semibold text-navy">{t.rating}</span>
                    <span className="text-navy/40">(120+)</span>
                  </div>
                  <h3 className="font-heading text-lg font-bold leading-snug">{t.title}</h3>
                  <div className="mt-2 flex items-center gap-3 text-sm text-navy/50">
                    <span>📍 {t.location}</span>
                    <span>🕑 {t.duration}</span>
                  </div>

                  <div className="mt-auto flex items-center justify-between pt-5">
                    <div>
                      <span className="text-xs text-navy/40">from</span>
                      <p className="font-heading text-xl font-bold text-brand">{t.price}</p>
                    </div>
                    <a
                      href={`https://wa.me/${CONTACT.wa}?text=Hi%2C%20I%20want%20to%20book%20${encodeURIComponent(
                        t.title,
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rounded-full bg-accent px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-accent-dark"
                    >
                      Book Now
                    </a>
                  </div>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
